import { render, staticRenderFns } from "./ModalBooksHistory.vue?vue&type=template&id=11ec570c&scoped=true&"
import script from "./ModalBooksHistory.vue?vue&type=script&lang=js&"
export * from "./ModalBooksHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModalBooksHistory.vue?vue&type=style&index=0&id=11ec570c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ec570c",
  null
  
)

export default component.exports